module.exports = __webpack_public_path__ + "static/media/expire.aa96d62e.svg";